<div class="em-feed-row">
  <div class="em-feed-row__well" [class]="'em-feed-row__well--' + row().kind" aria-hidden="true">
    @switch (row().kind) {
      @case ('pricing') {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M3.6 11.5 11 4.1a2 2 0 0 1 1.4-.6H18a2 2 0 0 1 2 2v5.6a2 2 0 0 1-.6 1.4l-7.4 7.4a2 2 0 0 1-2.8 0l-4.6-4.6a2 2 0 0 1 0-2.8Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
          <circle cx="15.4" cy="8.6" r="1.3" fill="currentColor"/>
        </svg>
      }
      @case ('profile') {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.7"/>
          <circle cx="8.5" cy="11" r="2" stroke="currentColor" stroke-width="1.6"/>
          <path d="M13 10h5M13 13h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      }
      @case ('battery') {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="8" width="15" height="9" rx="2" stroke="currentColor" stroke-width="1.7"/>
          <path d="M21 11v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      }
      @case ('po') {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
          <path d="M14 3v5h5M9 13h6M9 16h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      }
      @case ('message') {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 5h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9l-4 4V7a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
        </svg>
      }
      @default {
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
        </svg>
      }
    }
  </div>

  <div class="em-feed-row__main">
    <div class="em-feed-row__cat" [class]="'em-feed-row__cat--' + row().kind">{{ row().category }}</div>
    <button type="button" class="em-feed-row__title" (click)="open.emit()">{{ row().title }}</button>
    @if (row().subtitle) {
      <div class="em-feed-row__sub">{{ row().subtitle }}</div>
    }
  </div>

  <div class="em-feed-row__aside">
    <span class="em-feed-row__time">{{ row().timestamp }}</span>
    <button
      type="button"
      class="em-feed-action"
      [class.em-feed-action--primary]="row().actionVariant === 'primary'"
      [class.em-feed-action--ghost]="row().actionVariant === 'ghost'"
      (click)="open.emit()"
    >
      {{ row().actionLabel }}
    </button>
  </div>
</div>
